import { render, staticRenderFns } from "./AceCodeEditor.vue?vue&type=template&id=53f28aec&scoped=true&"
import script from "./AceCodeEditor.vue?vue&type=script&lang=js&"
export * from "./AceCodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./AceCodeEditor.vue?vue&type=style&index=0&id=53f28aec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f28aec",
  null
  
)

export default component.exports